import { FormControl, TextField, Autocomplete, Snackbar, Alert, Button } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { MDN_TRANSPORTS, SECURITIES, TRANSPORTS } from '../../../constants/constantList';
import { useDispatch } from 'react-redux';
import { api } from '../../../redux/api';
import _, { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';

const As2 = ({ connectionDetails, handleBodyContent, direction,repoPDC, screen, disableControl, useConnection }) => {
  const { t } = useTranslation();
  const SIGNING_ALORITHMS = [t('SHA1'), t('SHA224'), t('SHA256'), t('SHA384'), t('SHA512'), t('MD5')];
  const ENCRYPTION_ALGORITHMS = [t('3DES'), t('AES128-CBC'), t('AES256-CBC'), t('AES128-GCM'), t('AES256-GCM')];
  const MDN_SECURITIES = [t('SELECT'), t('SIGNEDSHA1'), t('SIGNEDSHA224'), t('SIGNEDSHA256'), t('SIGNEDSHA384'), t('SIGNEDSHA512'), t('SIGNEDMD5'), t('UNSIGNED')];
  const dispatch = useDispatch();
  const [receiverInIdentifiers, setReceiverInIdentifiers] = useState([]);
  const [receiverInIdentifier, setReceiverInIdentifier] = useState('');
  const [senderInIdentifier, setSenderInIdentifier] = useState('');
  const [senderOutIdentifiers, setSenderOutIdentifiers] = useState([]);
  const [senderOutIdentifier, setSenderOutIdentifier] = useState('');
  const [recieverOutIdentifier, setRecieverOutIdentifier] = useState('');
  const [signingCertificates, setSigningCertificates] = useState([]);
  const [signingCertificate, setSigningCertificate] = useState('');
  const [encryptions, setEncryptions] = useState([]);
  const [encryption, setEncryption] = useState('');
  const [httpsCertificates, setHttpsCertificates] = useState([]);
  const [httpsCertificate, setHttpsCertificate] = useState('');
  const [email, setEmail] = useState('');
  const [as2Url, setAs2Url] = useState('');
  const [transports, setTransports] = useState(TRANSPORTS.map(e => t(e)));
  const [transport, setTransport] = useState('');
  const [securites, setSecurites] = useState(SECURITIES.map(e => t(e)));
  const [security, setSecurity] = useState('');
  const [signingAlgos, setSigningAlgos] = useState(SIGNING_ALORITHMS);
  const [signingAlgo, setSigningAlgo] = useState('');
  const [encryptionAlgos, setEncryptionAlgos] = useState(ENCRYPTION_ALGORITHMS);
  const [encryptionAlgo, setEncryptionAlgo] = useState('');
  const [compression, setCompression] = useState('');
  const [mdnTransports, setMdnTransports] = useState(MDN_TRANSPORTS.map(e => t(e)));
  const [mdnTransport, setMdnTransport] = useState('');
  const [mdnUrl, setMdnUrl] = useState('');
  const [mdnSecurites, setMdnSecurites] = useState(MDN_SECURITIES);
  const [mdnSecurity, setMdnSecurity] = useState('');
  const [fileName, setFileName] = useState('');
  const [content, setContent] = useState(null);
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
  const [valueLabel, setValueLabel] = useState("");
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
   open: false,
   isFirstTime: false,
 });
 const workflowMappings = {
  [t('RECEIVER_AS2_ID')]: {
    stateSetter: setReceiverInIdentifier  ,
    key: "SENDER_AS2_ID",
    value: receiverInIdentifier 
  },
  [t('SENDER_AS2_ID')]: {
    stateSetter: setSenderInIdentifier ,
    key: "AS2_ID",
    value: senderInIdentifier 
  },
  [`${t('SENDER_AS2_ID')}_OUT`]: {
    stateSetter: setSenderOutIdentifier,
    key: "SENDER_AS2_ID",
    value: senderOutIdentifier 
  },
  [`${t('RECEIVER_AS2_ID')}_OUT`]: {
    stateSetter: setRecieverOutIdentifier,
    key: "AS2_ID",
    value: recieverOutIdentifier 
  },
  [t('LBL_X509_ALIAS_SIGNING')]: {
    stateSetter: setSigningCertificate ,
    key: "X509_ALIAS_SIGNING",
    value: signingCertificate 
  },
  [t('LBL_X509_ALIAS_ENCRYPTION')]: {
    stateSetter: setEncryption ,
    key: "X509_ALIAS_ENCRYPTION",
    value: encryption
  },
  [t('LBL_X509_ALIAS_HTTPS')]: {
    stateSetter: setHttpsCertificate ,
    key: "X509_ALIAS_HTTPS",
    value: httpsCertificate 
  },
  [t('LBL_EMAIL_ADDR')]: {
    stateSetter: setEmail ,
    key: "EMAIL",
    value: email 
  },
  [t('LBL_AS2_URL')]: {
    stateSetter: setAs2Url ,
    key: "AS2_URL",
    value: as2Url
  },
  [t('LBL_AS2_TRANSPORT')]: {
    stateSetter: setTransport ,
    key: "AS2_TRANSPORT",
    value: transport ,
  },
  [t('LBL_AS2_SECURITY')]: {
    stateSetter: setSecurity ,
    key: "AS2_SECURITY",
    value: security 
  },
  [t('LBL_AS2_SIGN_ALG')]: {
    stateSetter: setSigningAlgo ,
    key: "AS2_SIG_ALG",
    value: signingAlgo
  },
  [t('LBL_AS2_ENC_ALG')]: {
    stateSetter: setEncryptionAlgo ,
    key: "AS2_ENC_ALG",
    value: encryptionAlgo
  },
  [t('LBL_AS2_COMPRESSION')]: {
    stateSetter: setCompression ,
    key: "AS2_COMPRESSION",
    value: compression
  },
  [t('LBL_AS2_MDN_TRANSPORT')]: {
    stateSetter: setMdnTransport  ,
    key: "AS2_MDN_TRANSPORT",
    value: mdnTransport 
  },
  [t('LBL_AS2_MDN_URL')]: {
    stateSetter: setMdnUrl ,
    key: "AS2_MDN_URL",
    value: mdnUrl 
  },
  [t('LBL_AS2_MDN_SECURITY')]: {
    stateSetter: setMdnSecurity ,
    key: "AS2_MDN_SECURITY",
    value: mdnSecurity
  },
  [t('FILE_NAME')]: {
    stateSetter: setFileName ,
    key: "AS2_FILE_NAME",
    value: fileName
  },
 }
  const valuesHandler = (value) => {
    if (workflowMappings[valueLabel]) {
      const { stateSetter, key } = workflowMappings[valueLabel];
      stateSetter(value);
      onInputChange(key, value);
    }
  };
  const getFontWeight = (control, currentValue, defaultValue, useConnection) => {
    if (!repoPDC) return "normal";
    if (['AS2_TRANSPORT', 'AS2_SECURITY', 'AS2_MDN_TRANSPORT'].includes(control) && currentValue === t('SELECT')) return 'normal';
    
    // Special handling for AS2_MDN_SECURITY
    if (control === 'AS2_MDN_SECURITY') {
      if (currentValue === t('SELECT')) return 'normal';
      // Check if the original value was 'Signed' and current is 'Signed-SHA1'
      if (repoPDC[control] === 'Signed' && currentValue === 'Signed-SHA1') return 'normal';
      // Check if current value matches repository value
      return repoPDC[control] !== currentValue && useConnection === "preDefined" ? "bold" : "normal";
    }

    // Default handling for other controls
    if (!(control in repoPDC) && currentValue === defaultValue) return "normal";
    return repoPDC?.[control] !== currentValue && useConnection === "preDefined" ? "bold" : "normal";
  };
  
  const fontWeights = useMemo(() => {
    return {
      SENDER_AS2_ID: getFontWeight(
        "SENDER_AS2_ID",
        receiverInIdentifier,
        "",
        useConnection
      ),
      AS2_ID: getFontWeight("AS2_ID", senderInIdentifier, "", useConnection),
      AS2_ID_OUT: getFontWeight("SENDER_AS2_ID", senderOutIdentifier, "", useConnection),
      RECEIVER_AS2_ID_OUT: getFontWeight("AS2_ID", recieverOutIdentifier, "", useConnection),
      X509_ALIAS_SIGNING: getFontWeight(
        "X509_ALIAS_SIGNING",
        signingCertificate,
        "",
        useConnection
      ),
      X509_ALIAS_ENCRYPTION: getFontWeight(
        "X509_ALIAS_ENCRYPTION",
        encryption,
        "",
        useConnection
      ),
      X509_ALIAS_HTTPS: getFontWeight(
        "X509_ALIAS_HTTPS",
        httpsCertificate,
        "",
        useConnection
      ),
      EMAIL: getFontWeight("EMAIL", email,"", useConnection),
      AS2_URL: getFontWeight("AS2_URL", as2Url,"", useConnection),
      AS2_TRANSPORT: getFontWeight("AS2_TRANSPORT", transport, t('SELECT'), useConnection),
      AS2_SECURITY: getFontWeight("AS2_SECURITY", security, t('SELECT'), useConnection),
      AS2_SIG_ALG: getFontWeight("AS2_SIG_ALG", signingAlgo, 'SHA1', useConnection),
      AS2_ENC_ALG: getFontWeight("AS2_ENC_ALG", encryptionAlgo, '3DES', useConnection),
      AS2_COMPRESSION: getFontWeight(
        "AS2_COMPRESSION",
        compression,
        "FALSE",
        useConnection
      ),
      AS2_MDN_TRANSPORT: getFontWeight(
        "AS2_MDN_TRANSPORT",
        mdnTransport,
        t('SELECT'),
        useConnection
      ),
      AS2_MDN_URL: getFontWeight("AS2_MDN_URL", mdnUrl, "", useConnection),
      AS2_MDN_SECURITY: getFontWeight(
        "AS2_MDN_SECURITY",
        mdnSecurity,
        t('SELECT'),
        useConnection
      ),
      AS2_FILE_NAME: getFontWeight("AS2_FILE_NAME", fileName, "", useConnection),
    };
  }, [
    receiverInIdentifier,
    senderInIdentifier,
    senderOutIdentifier,
    recieverOutIdentifier,
    signingCertificate,
    encryption,
    httpsCertificate,
    email,
    as2Url,
    transport,
    security,
    signingAlgo,
    encryptionAlgo,
    compression,
    mdnTransport,
    mdnUrl,
    mdnSecurity,
    fileName,
    useConnection,
  ]);
  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  }

  const onInputChange = (name, value) => {
    if (screen === "GET_DATA" || screen === "SEND_DATA") {
      if(name === 'AS2_ID') {
         setContent({add: {[name]: value, NAME: value}})
      } else  setContent({ [name]: value === t('SELECT') ? null : value });
    } else {
      setContent((prev) => {
        return { ...prev, [name]: value };
      });
    }
  }

  const debouncedContentUpdate = debounce(handleBodyContent, 500);

  useEffect(() => {
   if (!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
  }, [content]);

  useEffect(() => {
    dispatch(api.endpoints.getEcryptionList.initiate()).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        setEncryptionAlgos(res?.data?.data);
      }
      if (res?.data?.current_state === 'ERROR') {
        setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
      }
    });

    dispatch(api.endpoints.getAS2Ids.initiate()).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        if (direction === 'IN') setReceiverInIdentifiers(Object.keys(res?.data?.data));
        else setSenderOutIdentifiers(Object.keys(res?.data?.data));
      }
      if (res?.data?.current_state === 'ERROR') {
        setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
      }
    });

    // Load certificate aliases for dropdowns
    dispatch(api.endpoints.getPrivateKeys.initiate({private_key: true}, { forceRefetch: true })).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        setSigningCertificates(res?.data?.data);
        setEncryptions(res?.data?.data);
        setHttpsCertificates(res?.data?.data);
      }
      if (res?.data?.current_state === 'ERROR') {
        setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
      }
    });
  }, []);

  useEffect(() => {
    setSigningCertificate(connectionDetails?.X509_ALIAS_SIGNING || '');
    setEncryption(connectionDetails?.X509_ALIAS_ENCRYPTION || '');
    setHttpsCertificate(connectionDetails?.X509_ALIAS_HTTPS || '');
    setEmail(connectionDetails?.EMAIL || '');
    setAs2Url(connectionDetails?.AS2_URL || '');
    setTransport(connectionDetails?.AS2_TRANSPORT || '-- Select --');
    setSecurity(connectionDetails?.AS2_SECURITY || '-- Select --');
    setSigningAlgo(connectionDetails?.AS2_SIG_ALG || 'SHA1');
    setEncryptionAlgo(connectionDetails?.AS2_ENC_ALG || '3DES');
    setCompression(connectionDetails?.AS2_COMPRESSION || 'FALSE');
    setMdnTransport(connectionDetails?.AS2_MDN_TRANSPORT || '-- Select --');
    setMdnUrl(connectionDetails?.AS2_MDN_URL || '');
    if (connectionDetails?.AS2_MDN_SECURITY !== 'Signed') setMdnSecurity(connectionDetails?.AS2_MDN_SECURITY || '-- Select --');
    else setMdnSecurity('Signed-SHA1');
    if (direction === 'IN') {
      setReceiverInIdentifier(connectionDetails?.SENDER_AS2_ID || '');
      setSenderInIdentifier(connectionDetails?.AS2_ID || connectionDetails?.RECEIVER_AS2_ID || '');
    }
    if (direction === 'OUT') {
      setFileName(connectionDetails?.AS2_FILE_NAME || '');
      setRecieverOutIdentifier(connectionDetails?.AS2_ID || '');
      setSenderOutIdentifier(connectionDetails?.SENDER_AS2_ID || '');
    }
    setContent({ ...connectionDetails })
  }, [connectionDetails]);

  return (
    <>
      {direction === "IN" && (
        <>
          <div style={{ display: "flex", gap: "4px" }}>
            <Autocomplete
              disablePortal
              disabled={disableControl || false}
              options={receiverInIdentifiers}
              value={receiverInIdentifier}
              sx={{ maxHeight: 300, input: { fontWeight: fontWeights.SENDER_AS2_ID }, }}
              className="width-100"
              getOptionLabel={(option) => option}
              onChange={(e, value) => {
                onInputChange("SENDER_AS2_ID", value);
                setReceiverInIdentifier(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("RECEIVER_AS2_ID")}
                  onChange={(e) => {
                    onInputChange("SENDER_AS2_ID", e.target.value);
                    setReceiverInIdentifier(e.target.value);
                  }}
                  variant="outlined"
                  size="small"
                  name={"RECEIVER_IDENTIFIER"}
                  autoComplete="off"
                />
              )}
            />
            {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("RECEIVER_AS2_ID"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                disabled={disableControl || false}
                size="small"
                label={t("SENDER_AS2_ID")}
                type="text"
                value={senderInIdentifier}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setSenderInIdentifier(e.target.value);
                }}
                className={"width-100"}
                sx={{
                  input: {
                    fontWeight: fontWeights.AS2_ID,
                  },
                }}
                name={"AS2_ID"}
                autoComplete="off"
              />
            </FormControl>
            {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("SENDER_AS2_ID"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
        </>
      )}
      {direction === "OUT" && (
        <>
          <div style={{ display: "flex", gap: "4px" }}>
            <Autocomplete
              disablePortal
              disabled={disableControl || false}
              options={senderOutIdentifiers}
              value={senderOutIdentifier}
              sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_ID_OUT } }}
              className="width-100"
              getOptionLabel={(option) => option}
              onChange={(e, value) => {
                onInputChange("SENDER_AS2_ID", value);
                setSenderOutIdentifier(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("SENDER_AS2_ID")}
                  onChange={(e) => {
                    onInputChange("SENDER_AS2_ID", e.target.value);
                    setSenderOutIdentifier(e.target.value);
                  }}
                  variant="outlined"
                  size="small"
                  name={"RECEIVER_IDENTIFIER"}
                  autoComplete="off"
                />
              )}
            />
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(`${t("SENDER_AS2_ID")}_OUT`);
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                disabled={disableControl || false}
                size="small"
                label={t("RECEIVER_AS2_ID")}
                type="text"
                value={recieverOutIdentifier}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setRecieverOutIdentifier(e.target.value);
                }}
                className={"width-100"}
                sx={{
                  input: {
                    fontWeight: fontWeights.RECEIVER_AS2_ID_OUT,
                  },
                }}
                name={"AS2_ID"}
                autoComplete="off"
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(`${t("RECEIVER_AS2_ID")}_OUT`);
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
        </>
      )}
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={signingCertificates}
          getOptionLabel={(option) => option}
          value={signingCertificate}
          sx={{ maxHeight: 300,input: { fontWeight: fontWeights.X509_ALIAS_SIGNING },  }}
          onChange={(e, value) => {
            onInputChange("X509_ALIAS_SIGNING", value);
            setSigningCertificate(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_X509_ALIAS_SIGNING")}
              onChange={(e) => {
                onInputChange("X509_ALIAS_SIGNING", e.target.value);
                setSigningCertificate(e.target.value);
              }}
              variant="outlined"
              size="small"
              name="SINGING_CERTIFICATE"
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_X509_ALIAS_SIGNING"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={encryptions}
          getOptionLabel={(option) => option}
          value={encryption}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.X509_ALIAS_ENCRYPTION }, }}
          onChange={(e, value) => {
            onInputChange("X509_ALIAS_ENCRYPTION", value);
            setEncryption(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_X509_ALIAS_ENCRYPTION")}
              onChange={(e) => {
                onInputChange("X509_ALIAS_ENCRYPTION", e.target.value);
                setEncryption(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"ENCYRPTION_CERTIFICATE"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_X509_ALIAS_ENCRYPTION"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={httpsCertificates}
          getOptionLabel={(option) => option}
          value={httpsCertificate}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.X509_ALIAS_HTTPS }, }}
          onChange={(e, value) => {
            onInputChange("X509_ALIAS_HTTPS", value);
            setHttpsCertificate(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_X509_ALIAS_HTTPS")}
              onChange={(e) => {
                onInputChange("X509_ALIAS_HTTPS", e.target.value);
                setHttpsCertificate(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"HTTPS_CERTIFICATE"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_X509_ALIAS_HTTPS"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            disabled={disableControl || false}
            size="small"
            label={t("LBL_EMAIL_ADDR")}
            type="text"
            value={email}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setEmail(e.target.value);
            }}
            className={"width-100"}
            sx={{
              input: {
                fontWeight: fontWeights.EMAIL,
              },
            }}
            name={"EMAIL"}
            autoComplete="off"
          />
        </FormControl>
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_EMAIL_ADDR"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            disabled={disableControl || false}
            size="small"
            label={t("LBL_AS2_URL")}
            type="text"
            value={as2Url}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setAs2Url(e.target.value);
            }}
            className={"width-100"}
            sx={{
              input: {
                fontWeight: fontWeights.AS2_URL,
              },
            }}
            name={"AS2_URL"}
            autoComplete="off"
          />
        </FormControl>
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_URL"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={transports}
          getOptionLabel={(option) => option}
          value={transport}
          sx={{ maxHeight: 300,input: { fontWeight: fontWeights.AS2_TRANSPORT }  }}
          onChange={(e, value) => {
            if (value === "-- Select --") onInputChange("AS2_TRANSPORT", value);
            else onInputChange("AS2_TRANSPORT", value);
            setTransport(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_TRANSPORT")}
              onChange={(e) => {
                if (e.target.value === "-- Select --")
                  onInputChange("AS2_TRANSPORT", e.target.value);
                else onInputChange("AS2_TRANSPORT", e.target.value);
                setTransport(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"TRANSPORT"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_TRANSPORT"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={securites}
          getOptionLabel={(option) => option}
          value={security}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_SECURITY } }}
          onChange={(e, value) => {
            if (value === "-- Select --") onInputChange("AS2_SECURITY", value);
            else onInputChange("AS2_SECURITY", value);
            setSecurity(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_SECURITY")}
              onChange={(e) => {
                if (e.target.value === "-- Select --")
                  onInputChange("AS2_SECURITY", e.target.value);
                else onInputChange("AS2_SECURITY", e.target.value);
                setSecurity(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"SECURITY"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_SECURITY"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={signingAlgos}
          getOptionLabel={(option) => option}
          value={signingAlgo}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_SIG_ALG } }}
          onChange={(e, value) => {
            onInputChange("AS2_SIG_ALG", value);
            setSigningAlgo(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_SIGN_ALG")}
              onChange={(e) => {
                onInputChange("AS2_SIG_ALG", e.target.value);
                setSigningAlgo(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"SIGNING_ALGO"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_SIGN_ALG"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={encryptionAlgos}
          getOptionLabel={(option) => option}
          value={encryptionAlgo}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_ENC_ALG } }}
          onChange={(e, value) => {
            onInputChange("AS2_ENC_ALG", value);
            setEncryptionAlgo(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_ENC_ALG")}
              onChange={(e) => {
                onInputChange("AS2_ENC_ALG", e.target.value);
                setEncryptionAlgo(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"ENCRYPTION_ALGO"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_ENC_ALG"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={[t("TRUE"), t("FALSE")]}
          getOptionLabel={(option) => option}
          value={compression}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_COMPRESSION } }}
          onChange={(e, value) => {
            onInputChange("AS2_COMPRESSION", value);
            setCompression(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_COMPRESSION")}
              onChange={(e) => {
                onInputChange("AS2_COMPRESSION", e.target.value);
                setCompression(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"COMPRESSION"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_COMPRESSION"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={mdnTransports}
          getOptionLabel={(option) => option}
          value={mdnTransport}
          sx={{ maxHeight: 300, input: { fontWeight: fontWeights.AS2_MDN_TRANSPORT } }}
          onChange={(e, value) => {
            if (value === "-- Select --")
              onInputChange("AS2_MDN_TRANSPORT", value);
            else onInputChange("AS2_MDN_TRANSPORT", value);
            setMdnTransport(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_MDN_TRANSPORT")}
              onChange={(e) => {
                if (e.target.value === "-- Select --")
                  onInputChange("AS2_MDN_TRANSPORT", e.target.value);
                else onInputChange("AS2_MDN_TRANSPORT", e.target.value);
                setMdnTransport(e.target.value);
              }}
              variant="outlined"
              size="small"
              name={"MDN_TRANSPORT"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_MDN_TRANSPORT"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            disabled={disableControl || false}
            label={t("LBL_AS2_MDN_URL")}
            type="text"
            value={mdnUrl}
            onChange={(e) => {
              onInputChange("AS2_MDN_URL", e.target.value);
              setMdnUrl(e.target.value);
            }}
            sx={{
              input: {
                fontWeight: fontWeights.AS2_MDN_URL,
              },
            }}
            className={"width-100"}
            name={"MDN_URL"}
            autoComplete="off"
          />
        </FormControl>
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_MDN_URL"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{ display: "flex", gap: "4px" }}>
        <Autocomplete
          disablePortal
          disabled={disableControl || false}
          className="width-100"
          options={mdnSecurites}
          getOptionLabel={(option) => option}
          value={mdnSecurity}
          sx={{ maxHeight: 300,input: { fontWeight: fontWeights.AS2_MDN_SECURITY } }}
          onChange={(event, value) => {
            if (value === "-- Select --") {
              if (value === "Signed-SHA1") {
                onInputChange("AS2_MDN_SECURITY", "Signed");
                setMdnSecurity("Signed");
              } else {
                onInputChange("AS2_MDN_SECURITY", value);
                setMdnSecurity(value);
              }
            } else {
              onInputChange("AS2_MDN_SECURITY", value);
              setMdnSecurity(value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("LBL_AS2_MDN_SECURITY")}
              variant="outlined"
              onChange={(e) => {
                if (e.target.value === "-- Select --") {
                  if (e.target.value === "Signed-SHA1") {
                    onInputChange("AS2_MDN_SECURITY", "Signed");
                    setMdnSecurity("Signed");
                  } else {
                    onInputChange("AS2_MDN_SECURITY", e.target.value);
                    setMdnSecurity(e.target.value);
                  }
                } else {
                  onInputChange("AS2_MDN_SECURITY", e.target.value);
                  setMdnSecurity(e.target.value);
                }
              }}
              size="small"
              name={"MDN_SECURITY"}
              autoComplete="off"
            />
          )}
        />
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_AS2_MDN_SECURITY"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>

      {direction === "OUT" && (
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              disabled={disableControl || false}
              label={t("FILE_NAME")}
              type="text"
              value={fileName}
              onChange={(e) => {
                onInputChange("AS2_FILE_NAME", e.target.value);
                setFileName(e.target.value);
              }}
              className={"width-100"}
              sx={{
                input: {
                  fontWeight: fontWeights.AS2_FILE_NAME,
                },
              }}
              name={"AS2_FILE_NAME"}
              autoComplete="off"
            />
          </FormControl>
          {screen && screen === "SEND_DATA" && (
            <Button
              size="small"
              disabled={disableControl || false}
              variant="outlined"
              onClick={() => {
                setValueLabel(t("FILE_NAME"));
                setWorkflowSessionModal({ open: true, isFirstTime: true });
              }}
              sx={{ width: "40px", minWidth: "40px" }}>
              <MoreHorizOutlined fontSize="small" />
            </Button>
          )}
        </div>
      )}
      <WorkflowSessionModal
        valueLabel={valueLabel}
        showAccountData={true}
        showCallingWorkflow={true}
        showSystemData={true}
        showWorkflowSession={true}
        showDateAndTime={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={workflowMappings[valueLabel]?.value}
        valuesHandler={(value) => {
          valuesHandler(value);
        }}
      />
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
    </>
  )
}

export default As2